const d = ["#d46780", "#fdfbe4", "#798234"], E = ["#d46780", "#e8acb3", "#fdfbe4", "#bac082", "#798234"], G = [
  "#d46780",
  "#df91a3",
  "#f0c6c3",
  "#fdfbe4",
  "#d0d3a2",
  "#a3ad62",
  "#798234"
];
export {
  d as DIVERGING_PINK_GREEN_3,
  E as DIVERGING_PINK_GREEN_5,
  G as DIVERGING_PINK_GREEN_7
};
//# sourceMappingURL=index.es5699.js.map
